import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NewsPresentationComponent } from 'src/app/components/modals/news-presentation/news-presentation.component';
import { CardNew } from 'src/app/models/CardNew';
import { GlobalVariablesService } from '../global-variables.service';
import { ModalService } from './modal.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  constructor(private router: Router,
    private gvs: GlobalVariablesService,
    private storage: StorageService,
    private modalService: ModalService) { }

  async checkCardsNews(origin?) {
    let cardsNews: CardNew[] = await this.storage.getObject(this.gvs.CARDS_NEWS);
    if (origin) {
      if (origin === 'header') {
        cardsNews = cardsNews != null ? cardsNews.filter(x => x.visible === true) : [];
      } else {
        cardsNews = cardsNews != null ? cardsNews.filter(x => origin.includes(x.screen.split('/').slice(-1)) && x.visible === true) : [];
      }
    } else {
      if (this.router.url.includes('/home')) {
        cardsNews = cardsNews != null ? cardsNews.filter(x => x.visible === true) : [];
      }
      else {
        cardsNews = cardsNews != null ? cardsNews.filter(x => this.router.url.includes(x.screen) && x.visible === true) : [];
        // cardsNews = cardsNews.filter(x => x.screen.includes(this.router.url) && x.visible === true);
      }
    }
    if (cardsNews != null && cardsNews.length > 0) {
      const contentModal = await this.modalService.show(NewsPresentationComponent, "newsModal", { cardsNews: cardsNews, screen: this.router.url }, ['w-modal-md', 'report-modal'])
      await contentModal.present().then();
      return contentModal;
    }
  }
}
